var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2192 28.7171C9.30204 26.1727 8.57303 20.6496 10.9291 17.2672C12.3992 15.1568 14.8354 13.8056 16.5214 13.2731C18.2073 12.7405 21.0603 12.4157 23.0891 13.1844C25.4245 14.0692 26.2655 14.5491 27.8827 16.0246C29.5 17.5 30.4241 19.1641 30.8999 21.1727C31.3757 23.1812 31.1481 24.0093 30.5455 24.9005C30.2792 25.433 28.9833 26.6756 27.7052 26.6756C26.4271 26.6756 25.5158 26.1431 25.0424 25.7881C24.4525 25.3596 23.7615 24.3694 23.7111 23.1253C23.6421 21.4231 22.3797 20.502 22.0246 20.285C21.4921 19.9595 20.679 19.6709 19.4506 19.8412C18.0125 20.0405 17.2316 20.8175 16.8766 21.2613C16.5216 21.7051 16.1665 22.4152 16.1665 23.5691C16.1665 24.7229 16.46 25.7484 16.7878 26.4981C17.1391 27.3014 17.8056 28.5287 18.7399 29.6048C19.7998 30.8256 21.1617 31.8772 22.024 32.3563C22.8228 32.8001 24.1246 33.1255 24.2429 33.1551",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8159 8.12501C13.7686 6.34983 22.3782 4.39714 28.1476 8.12501",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8052 23.214C19.8648 26.5814 23.1691 31.1099 28.6809 29.8709",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0537 15.4921C31.2016 14.072 28.6809 12.0578 28.1483 11.6754C22.6097 7.69904 16.0771 9.1902 12.0829 11.6755C10.7515 12.563 8.73972 14.4524 8 15.7584",
    stroke: "#EB5424",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7871 32.6224C15.4853 31.5573 13.302 28.9929 12.8821 25.6105C12.709 24.2164 12.6978 23.3268 12.793 22.5039C13.0182 20.5557 13.7863 19.5318 14.0358 19.2198C14.3907 18.776 15.3032 17.8176 16.4321 17.1784C17.3142 16.7176 19.0778 16.3066 19.8939 16.2908C20.5283 16.2784 21.9174 16.4971 23.178 17.0008C24.2666 17.4358 25.1542 18.37 25.752 19.0423C26.8396 20.2653 27.3497 21.9715 27.3497 23.3029",
    stroke: "#EB5424",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/mfa.dbb25c40594a26e64994620d6c72f534.svg";
export { ForwardRef as ReactComponent };